// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1CEv-","question":"Question_question__3z4Hk","description":"Question_description__3a5M4"};